import Store, { actions } from '@store';
import AnimationApp from 'src/views/animation/animation';

import Common from '../common';

import template from './animation-modal.html';

export const hiddenClassName = 'animation-modal-hidden';

export default class AnimationModal extends Common {
  selector = '.animation-modal';

  constructor (openButton) {
    super(template);
    this.openButton = openButton;
    this.closeButton = this.component.querySelector('button#close');
    this.modalContentInner = this.component.querySelector(
      '.animation-modal-content-inner'
    );
  }

  init () {
    this.openButton.addEventListener('click', () => {
      this.showModal();
    });
  }

  async fetchPages () {
    await INKIVE.EditorFacade.handle('page', 'saveState');

    const pages = Store.getState().editor.pagesOrder;

    await Store.dispatch(actions.page.fetchPages({
      pages,
      skipRenderThumbnail: true
    }));
  }

  appendPlayerElement () {
    this.modalContentInner.id = 'animation-preview-container';

    this.addEventListeners([
      [document, 'keydown', this.onKeydown],
      [this.closeButton, 'click', this.closeModal],
      [this.modalContentInner, 'click', this.onContentClick]
    ]);

    this.player = AnimationApp;
  }

  async showModal () {
    await this.fetchPages();

    if (!this.player) this.appendPlayerElement();

    this.component.classList.remove(hiddenClassName);

    this.player.mountApp({
      onComplete: this.closeModal.bind(this)
    });
  }

  onKeydown (e) {
    if (e.code === 'Escape') this.closeModal();
  }

  onContentClick (e) {
    const notClickOnVideo = e.target === e.currentTarget;
    if (notClickOnVideo) this.closeModal();
  }

  afterClose () {
    this.removeEventListeners();
    this.player.closeApp();
    this.player = null;
  }

  closeModal () {
    this.component.classList.add(hiddenClassName);
    this.afterClose();
  }
}
